/* TOO MUCH round 2 base behaviour (loaded on every page, deferred). No colours, no layout.
   - [data-tm-inview]  : children get .is-in when they enter the viewport (entry panels). Skins hang motion on it,
                         scoped to [data-tm-inview-ready] (set here), so without JS everything shows as final.
                         Reduced motion or no IntersectionObserver: everything is .is-in at once.
   - <tm-look-card>    : option chips / swatches pick the variant, price, link, photo and add-to-cart id follow.
   - <tm-complete-look>: swaps the fallback pieces for Search & Discovery complementary products when they exist. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ------------------------------------------------------------ in view */
  function watch(root) {
    var items = Array.prototype.slice.call(root.children);
    if (reduced || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    // skins start their "before" state only under this attribute, so without JS nothing stays hidden
    root.setAttribute('data-tm-inview-ready', '');
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.35 }
    );
    items.forEach(function (el) { io.observe(el); });
  }

  function initInView(scope) {
    (scope || document).querySelectorAll('[data-tm-inview]').forEach(function (root) {
      if (root._tmWatched) return;
      root._tmWatched = true;
      watch(root);
    });
  }

  /* ------------------------------------------------------------ look card */
  class TmLookCard extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      this._bound = true;
      try {
        this.variants = JSON.parse(this.querySelector('[data-tm-lc-variants]').textContent);
      } catch (error) {
        this.variants = [];
      }
      this.addEventListener('change', (event) => {
        if (event.target.matches('input[type="radio"]')) this.update();
      });
    }

    update() {
      var chosen = Array.prototype.map.call(this.querySelectorAll('[data-tm-lc-option]'), function (set) {
        var input = set.querySelector('input:checked');
        var out = set.querySelector('[data-tm-lc-option-value]');
        if (input && out) out.textContent = input.value;
        return input ? input.value : null;
      });
      var variant = this.variants.find(function (v) {
        return v.options.every(function (value, i) { return value === chosen[i]; });
      });
      var holder = this.querySelector('factory-add-button');
      var button = this.querySelector('[data-tm-lc-add]');
      var soldLabel = this.dataset.soldLabel || '';
      var addLabel = this.dataset.addLabel || '';
      if (!variant) {
        if (button) {
          button.disabled = true;
          button.textContent = soldLabel;
        }
        return;
      }
      if (holder) holder.dataset.variantId = String(variant.id);
      if (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? addLabel : soldLabel;
      }
      var price = this.querySelector('[data-tm-lc-price]');
      if (price) price.textContent = variant.price;
      var compare = this.querySelector('[data-tm-lc-compare]');
      if (compare) {
        compare.hidden = !variant.compare;
        compare.textContent = variant.compare || '';
      }
      var link = this.querySelector('[data-tm-lc-link]');
      if (link && variant.url) link.href = variant.url;
      var image = this.querySelector('.tm-lcard__img');
      if (image && variant.image) {
        image.removeAttribute('srcset');
        image.src = variant.image;
      }
    }
  }
  if (!customElements.get('tm-look-card')) customElements.define('tm-look-card', TmLookCard);

  /* ------------------------------------------------------------ complete the look */
  class TmCompleteLook extends HTMLElement {
    connectedCallback() {
      if (this._bound || !this.dataset.productId || !this.dataset.url) return;
      this._bound = true;
      var load = () => this.load();
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) {
              observer.disconnect();
              load();
            }
          },
          { rootMargin: '0px 0px 400px 0px' }
        );
        observer.observe(this);
      } else {
        load();
      }
    }

    async load() {
      var d = this.dataset;
      try {
        var response = await fetch(
          d.url + '?product_id=' + encodeURIComponent(d.productId) + '&section_id=' + encodeURIComponent(d.sectionId) +
            '&intent=complementary&limit=' + (d.limit || 3)
        );
        if (!response.ok) return;
        var doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        var fresh = doc.querySelector('[data-tm-complete-list]');
        var current = this.querySelector('[data-tm-complete-list]');
        if (fresh && current && fresh.children.length > 0) current.replaceWith(fresh);
      } catch (error) {
        /* keep the server-rendered pieces */
      }
    }
  }
  if (!customElements.get('tm-complete-look')) customElements.define('tm-complete-look', TmCompleteLook);

  /* Round 3: the store menu's "Wishlist" item links to #wishlist (their old Palo Alto drawer). Point every such link
     at this theme's wishlist page (the header heart's href: /collections/all?view=wishlist, no page to create). */
  var TM_WL_LINKS = 'a[href="#wishlist"], a[href$="/#wishlist"]';
  function tmWishlistUrl() {
    var heart = document.querySelector('[data-tm-wl-link]');
    return (heart && heart.getAttribute('href')) || '/collections/all?view=wishlist';
  }
  function tmWishlistLinks() {
    var url = tmWishlistUrl();
    document.querySelectorAll(TM_WL_LINKS).forEach(function (a) { a.setAttribute('href', url); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tmWishlistLinks);
  else tmWishlistLinks();
  /* The phone menu is rendered again by Horizon after load, so its "Wishlist" kept #wishlist (05.10 QA: tapping it did
     nothing). Catch the click on any such link, whenever it was rendered. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest(TM_WL_LINKS);
    if (!link) return;
    event.preventDefault();
    window.location.href = tmWishlistUrl();
  }, true);

  /* Round 3: /#concierge from another page. The browser only jumps to the anchor once every image has loaded (seconds
     on a phone, then a long smooth scroll). Jump as soon as the section exists, clear of the sticky header. */
  function tmHashJump() {
    if (!window.location.hash || window.location.hash.length < 2) return;
    var target = null;
    try { target = document.getElementById(decodeURIComponent(window.location.hash.slice(1))); } catch (error) { return; }
    if (!target || !target.closest('.shopify-section')) return;
    target.scrollIntoView({ block: 'start', behavior: 'instant' });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tmHashJump);
  else tmHashJump();

  /* Round 3: Categories / Brands buttons (snippets/tm-shopby.liquid). One list open at a time, Escape and a click
     outside close it. Plain <details>, so without this script the lists still open and close. */
  document.addEventListener('toggle', function (event) {
    var item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.classList.contains('tm-shopby__item') || !item.open) return;
    document.querySelectorAll('.tm-shopby__item[open]').forEach(function (other) {
      if (other !== item) other.open = false;
    });
  }, true);
  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.tm-shopby__item')) return;
    document.querySelectorAll('.tm-shopby__item[open]').forEach(function (item) { item.open = false; });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var open = document.querySelector('.tm-shopby__item[open]');
    if (!open) return;
    open.open = false;
    var summary = open.querySelector('summary');
    if (summary) summary.focus();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initInView(); });
  else initInView();
  document.addEventListener('shopify:section:load', function (event) { initInView(event.target); });
})();
